// set
const html = document.documentElement.style,
      body = document.body.style,
      breakpoint = window.matchMedia('(min-width: 768px)')


// navi menu
const menuIcon = document.querySelector('.l-header__toggle'),
      menuText = document.querySelector('.l-header__toggle-text'),
      menuList = document.querySelector('.l-header__navigation'),
      menuTextOpen = 'MENU',
      menuTextClose = 'CLOSE',
      elements = document.querySelectorAll('.l-header__menu > li')

function classAdd(){
  menuIcon.classList.add('is-active')
  menuList.classList.add('is-active')
  menuText.textContent = menuTextClose
  html.overflow = 'hidden'
  body.overflow = 'hidden'
  let i = 1
  Array.prototype.forEach.call(elements, element => {
    setTimeout(() => {element.classList.add('is-anima')}, 120 * i)
    i++
  })
}
function classRemove(){
  menuIcon.classList.remove('is-active')
  menuList.classList.remove('is-active')
  menuText.textContent = menuTextOpen
  html.overflow = ''
  body.overflow = ''
  Array.prototype.forEach.call(elements, element => {
    element.classList.remove('is-anima')
  })
}

window.addEventListener('resize', function(){
  if(breakpoint.matches === true){ classRemove() }
})
menuIcon.addEventListener('click', function(){
  if(this.classList.contains('is-active')){ classRemove() }
  else{ classAdd() }
})


// totop
const totop = document.querySelector('.l-footer-totop')
window.addEventListener('scroll', function(){
  if(window.scrollY > 600){ totop.classList.add('is-active') }
  else{ totop.classList.remove('is-active')}
})


// contact
document.querySelector('[name="zip[data][1]"]').addEventListener('keyup', function(){
  AjaxZip3.zip2addr('zip[data][0]','zip[data][1]','address','address','address')
})

const formError = document.querySelectorAll('.error')
for(let i = 0; i < formError.length; i++){
  formError[i].parentElement.classList.add('is-error')
}